export default __webpack_public_path__ + "static/B45_57-5a77aae0179c84cf61273e4fb02e6c64.png";